import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

/**
 * Scrolls the window to the top on every route change AND emits an
 * analytics page-view. This is the single choke point in the SPA that
 * fires on every route transition, so it's the natural home for the
 * tracker init call.
 * Exception: routes that opt-in to scroll restoration themselves
 * (currently the home "/" which restores scroll after coming back
 * from an event detail) are skipped here — Home.jsx handles its own
 * scroll restoration via sessionStorage.
 */
const KEEP_SCROLL_ROUTES = new Set(["/", ""]);
let _analyticsInited = false;

export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (!_analyticsInited) {
            initAnalytics();
            _analyticsInited = true;
        }
        // Best-effort, non-blocking — analytics failures never surface.
        try { trackPageView(pathname); } catch { /* noop */ }
        if (KEEP_SCROLL_ROUTES.has(pathname)) return;
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);
    return null;
}
